type Color = {
    light?: string
    main?: string
    dark?: string
}
export const PrimaryColor: Color = {
    light: "#e3f2fd",
    main: "#90caf9",
    dark: "#42a5f5"
}
export const SecondaryColor: Color = {
    light: "#f3e5f5",
    main: "#ce93d8",
    dark: "#ab47bc"
}
export const ErrorColor: Color = {
    light: "#e57373",
    main: "#f44336",
    dark: "#d32f2f"
}

export const WarningColor: Color = {
    light: "#ffb74d",
    main: "#ffa726",
    dark: "#f57c00"
}
export const InfoColor: Color = {
    light: "#4fc3f7",
    main: "#29b6f6",
    dark: "#0288d1"
}
export const SuccessColor: Color = {
    light: "#81c784",
    main: "#66bb6a",
    dark: "#388e3c"
}

export const NeutralColor: Color = {
    light: '#f5f5f5',
    dark: '#212121'

}